/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');

window.slick = require('slick-carousel');
window.fancybox = require('@fancyapps/fancybox');
window.toastr = require('toastr');

$(function() {

    $("#lang-selector").click(function(){
        $(this).toggleClass('show');
        $("#lang-list").slideToggle('fast');
    });

    $("a.cta.share").click(function(){
        $('.share-box').toggleClass('show');
        return false;
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) { // Esc
            $('.share-box').removeClass('show');
            $("#lang-selector").removeClass('show');
            $("#lang-list").slideUp('fast');
        }
    });

    $(document).click(function() {
        $('.share-box').removeClass('show');
        $("#lang-selector").removeClass('show');
        $("#lang-list").slideUp('fast');
    });
    
    $("#lang-list, #lang-selector, .share-box, .cta.share").click(function(event) {
        event.stopPropagation();
    });

    $("html, body").on('click','#share-modal', function(){
        $('.share-box.modal').toggleClass('show');
        return false;
    });

    $("#certificate-link").click(function() {
         $('html, body').animate({
            scrollTop: $("#certificate").offset().top
        }, 500);
        return false;
    })

    $("#copy-to-clipboard").click(function() {
        let copyText = document.getElementById("clipboard");

        /* Select the text field */
        copyText.select();

        /* Copy the text inside the text field */
        document.execCommand("copy");

        toastr.success("Copied to clipboard");
    })

    $("html, body").on('click', '#copy', function() {
        var copyText = document.getElementById("copy").title;

        document.addEventListener('copy', function(event) {
            event.clipboardData.setData('text/plain', copyText);
            event.preventDefault();
            document.removeEventListener('copy', handler, true);
        }, true);

        document.execCommand('copy');

        toastr.success("Copied to clipboard");

        return false;
    })


    $(".video-slick").on('init', function(){
        $(this).removeClass('not-init');
    });

    const videoItem = $('.video-slick .item');

    if(videoItem.length <= 3) {
        videoItem.addClass("no-slide");
    }

    $('.video-slick').slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        appendArrows: '.slick-nav',
        appendDots: '.slick-nav',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            },
        ]
    });

    // let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    let ua = window.navigator.userAgent;
    let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    let webkit = !!ua.match(/WebKit/i);
    let iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    $('[data-fancybox="images"]').fancybox({
        beforeShow: function(instance, current) {
            let fileUrl = $(this.opts.$orig[0]).attr('href');
            let currentIndex = current.index + 1;
            let shareLink = $(this.opts.$orig[0]).attr('data-sharelink');
            
            $("#facebook").attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+ shareLink +'/?share=true');
            $("#twitter").attr('href', 'https://twitter.com/intent/tweet?url='+ shareLink +'/?share=true');
            $("#weibo").attr('href', 'http://service.weibo.com/share/share.php?url='+ shareLink +'/?share=true');
            $("#email").attr('href', 'mailto:?subject='+ shareSubject +'&body='+ shareLink +'/?share=true')
            $("#copy").attr('title', shareLink)

            let canDownload = $(this.opts.$orig[0]).attr('data-canDownload');
            
            if(canDownload == 1) {
                // if(iOS && !iOSSafari) {
                //     $("#image-download-url").attr('href', $(this.opts.$orig[0]).attr('href'));
                //     // $("#image-download-url").attr('target', '_blank');
                // } else {
                    let download_url = $(this.opts.$orig[0]).attr('data-download'); 
                    $("#image-download-url").attr('href', download_url);
                // }
            } else {
                $("#image-download-url").hide();
            }
            
        },
        image: {
            preload: true,
        },
        infobar: false,
        buttons: [
            "close"
        ],
        transitionEffect: "fade",
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption with-download">' + 
                '<a href="#" class="cta download-modal" id="image-download-url">Download</a>' +
                '<div class="share-wrap">' +
                    '<div class="share-box modal">' +
                        '<ul class="social-media modal">' +
                            '<li><a target="_blank" id="facebook" href="#" class="share-icon fb"></a></li>' +
                            '<li><a target="_blank" id="twitter" href="#" class="share-icon twitter"></a></li>' +
                            '<li><a target="_blank" id="weibo" href="#" class="share-icon anon"></a></li>' +
                            '<li><a id="email" href="#" class="share-icon mail"></a></li>' +
                            '<li><a id="copy" title="" href="javascript:void(0);" class="share-icon link"></a></li>' +
                        '</ul>' +
                        '<p>'+ shareText +'</p>' +
                    '</div>' + 
                    '<a href="#" id="share-modal" class="cta share modal">'+ shareTextLabel +'</a>' + 
                '</div>' +
            '</div>' +
            "</div>" +
            "</div>",
    });

    $('[data-fancybox="certs"]').fancybox({
        // afterLoad : function(instance, current) {
        //     var pixelRatio = window.devicePixelRatio || 1;
    
        //     if ( pixelRatio > 1.5 ) {
        //         current.width  = current.width  / pixelRatio;
        //         current.height = current.height / pixelRatio;
        //     }

        // },
        beforeShow: function(instance, current) {
            let fileUrl = $(this.opts.$orig[0]).attr('href');
            let currentIndex = current.index + 1;
            let shareLink = $(this.opts.$orig[0]).attr('data-sharelink');
            $("#facebook").attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+ shareLink +'/?share=true');
            $("#twitter").attr('href', 'https://twitter.com/intent/tweet?url='+ shareLink +'/?share=true');
            $("#weibo").attr('href', 'http://service.weibo.com/share/share.php?url='+ shareLink +'/?share=true');
            $("#email").attr('href', 'mailto:?subject='+ shareSubject +'&body='+ shareLink +'/?share=true')
            $("#copy").attr('title', shareLink)

            // if(iOS && !iOSSafari) {
            //     $("#image-download-url").attr('href', $(this.opts.$orig[0]).attr('href'));
            //     // $("#image-download-url").attr('target', '_blank');
            // } else {
                let download_url = $(this.opts.$orig[0]).attr('data-download'); 
                $("#image-download-url").attr('href', download_url);
            // }
        },
        infobar: false,
        buttons: [
            "close"
        ],
        transitionEffect: "fade",
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption with-download">' + 
                '<a href="#" class="cta download-modal" id="image-download-url">Download</a>' +
                '<div class="share-wrap">' +
                    '<div class="share-box modal">' +
                        '<ul class="social-media modal">' +
                            '<li><a target="_blank" id="facebook" href="#" class="share-icon fb"></a></li>' +
                            '<li><a target="_blank" id="twitter" href="#" class="share-icon twitter"></a></li>' +
                            '<li><a target="_blank" id="weibo" href="#" class="share-icon anon"></a></li>' +
                            '<li><a id="email" href="#" class="share-icon mail"></a></li>' +
                            '<li><a id="copy" title="" href="javascript:void(0);" class="share-icon link"></a></li>' +
                        '</ul>' +
                        '<p>'+ shareText +'</p>' +
                    '</div>' + 
                    '<a href="#" id="share-modal" class="cta share modal">'+ shareTextLabel +'</a>' + 
                '</div>' +
            '</div>' +
            "</div>" +
            "</div>",
    });

    // $('[data-fancybox="videos"]').fancybox({
    //     video: {
    //         tpl:
    //           '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}">' +
    //           '<source src="{{src}}" type="{{format}}" />' +
    //           'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
    //           "</video>",
    //         format: "", // custom video format
    //         autoStart: true
    //     },
    //     beforeShow: function(instance, current) {
    //         let fileUrl = $(this.opts.$orig[0]).attr('href');
    //         let currentIndex = current.index + 1;
    //         let shareLink = $(this.opts.$orig[0]).attr('data-sharelink');
    //         $("#facebook").attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+ shareLink +'/?share=true');
    //         $("#twitter").attr('href', 'https://twitter.com/intent/tweet?url='+ shareLink +'/?share=true');
    //         $("#weibo").attr('href', 'http://service.weibo.com/share/share.php?url='+ shareLink +'/?share=true');
    //         $("#email").attr('href', 'mailto:?subject='+ shareSubject +'&body='+ shareLink +'/?share=true')
    //         $("#copy").attr('title', shareLink)
            

    //         let canDownload = $(this.opts.$orig[0]).attr('data-canDownload');
            
    //         if(canDownload == 1) {
    //             if(iOS && navigator.userAgent.match('CriOS')) {
    //                 $("#image-download-url").hide();
    //             } else {
    //                 let download_url = $(this.opts.$orig[0]).attr('data-download'); 
    //                 $("#image-download-url").attr('href', download_url);
    //             }
    //         } else {
    //             $("#image-download-url").hide();
    //         }
    //     },
    //     infobar: false,
    //     arrows: false,
    //     buttons: [
    //         "close"
    //     ],
    //     transitionEffect: "fade",
    //     baseTpl:
    //         '<div class="fancybox-container" role="dialog" tabindex="-1">' +
    //         '<div class="fancybox-bg"></div>' +
    //         '<div class="fancybox-inner">' +
    //         '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
    //         '<div class="fancybox-toolbar">{{buttons}}</div>' +
    //         '<div class="fancybox-navigation">{{arrows}}</div>' +
    //         '<div class="fancybox-stage"></div>' +
    //         '<div class="fancybox-caption with-download">' + 
    //             '<a href="#" class="cta download-modal" id="image-download-url">Download</a>' +
    //             '<div class="share-wrap">' +
    //                 '<div class="share-box modal">' +
    //                     '<ul class="social-media modal">' +
    //                         '<li><a target="_blank" id="facebook" href="#" class="share-icon fb"></a></li>' +
    //                         '<li><a target="_blank" id="twitter" href="#" class="share-icon twitter"></a></li>' +
    //                         '<li><a target="_blank" id="weibo" href="#" class="share-icon anon"></a></li>' +
    //                         '<li><a id="email" href="#" class="share-icon mail"></a></li>' +
    //                         '<li><a id="copy" title="" href="javascript:void(0);" class="share-icon link"></a></li>' +
    //                     '</ul>' +
    //                     '<p>'+ shareText +'</p>' +
    //                 '</div>' + 
    //                 '<a href="#" id="share-modal" class="cta share modal">'+ shareTextLabel +'</a>' + 
    //             '</div>' +
    //         '</div>' +
    //         "</div>" +
    //         "</div>",
    // });

    $('[data-fancybox="inline"]').fancybox({
        toolbar: true,
        btnTpl: {
            smallBtn: ''
        },
        video: {
            tpl:
              '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}">' +
              '<source src="{{src}}" type="{{format}}" />' +
              'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
              "</video>",
            format: "", // custom video format
            autoStart: true
        },
        beforeShow: function(instance, current) {

            let fileUrl = $(this.opts.$orig[0]).attr('href');
            let shareLink = $(this.opts.$orig[0]).attr('data-sharelink');
            $("#facebook").attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+ shareLink +'/?share=true');
            $("#twitter").attr('href', 'https://twitter.com/intent/tweet?url='+ shareLink +'/?share=true');
            $("#weibo").attr('href', 'http://service.weibo.com/share/share.php?url='+ shareLink +'/?share=true');
            $("#email").attr('href', 'mailto:?subject='+ shareSubject +'&body='+ shareLink +'/?share=true')
            $("#copy").attr('title', shareLink)

            // if(iOS && !iOSSafari) {
            //     $("#image-download-url").attr('href', $(this.opts.$orig[0]).attr('href'));
            //     // $("#image-download-url").attr('target', '_blank');
            // } else {
                let download_url = $(this.opts.$orig[0]).attr('data-download'); 
                $("#image-download-url").attr('href', download_url);
            // }
        },
        infobar: false,
        arrows: false,
        buttons: [
            "close"
        ],
        transitionEffect: "fade",
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption with-download">' + 
                '<a href="#" class="cta download-modal" id="image-download-url">Download</a>' +
                '<div class="share-wrap">' +
                    '<div class="share-box modal">' +
                        '<ul class="social-media modal">' +
                            '<li><a target="_blank" id="facebook" href="#" class="share-icon fb"></a></li>' +
                            '<li><a target="_blank" id="twitter" href="#" class="share-icon twitter"></a></li>' +
                            '<li><a target="_blank" id="weibo" href="#" class="share-icon anon"></a></li>' +
                            '<li><a id="email" href="#" class="share-icon mail"></a></li>' +
                            '<li><a id="copy" title="" href="javascript:void(0);" class="share-icon link"></a></li>' +
                        '</ul>' +
                        '<p>'+ shareText +'</p>' +
                    '</div>' + 
                    '<a href="#" id="share-modal" class="cta share modal">'+ shareTextLabel +'</a>' + 
                '</div>' +
            '</div>' +
            "</div>" +
            "</div>",
    });

    var selector = 'a.play';

    $().fancybox({
        selector: selector,
        video: {
            tpl:
              '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}">' +
              '<source src="{{src}}" type="{{format}}" />' +
              'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
              "</video>",
            format: "", // custom video format
            autoStart: true
        },
        beforeShow: function(instance, current) {
            let fileUrl = $(this.opts.$orig[0]).attr('href');
            let currentIndex = current.index + 1;
            let shareLink = $(this.opts.$orig[0]).attr('data-sharelink');
            $("#facebook").attr('href', 'https://www.facebook.com/sharer/sharer.php?u='+ shareLink +'/?share=true');
            $("#twitter").attr('href', 'https://twitter.com/intent/tweet?url='+ shareLink +'/?share=true');
            $("#weibo").attr('href', 'http://service.weibo.com/share/share.php?url='+ shareLink +'/?share=true');
            $("#email").attr('href', 'mailto:?subject='+ shareSubject +'&body='+ shareLink +'/?share=true')
            $("#copy").attr('title', shareLink)
            

            let canDownload = $(this.opts.$orig[0]).attr('data-canDownload');
            
            if(canDownload == 1) {
                if(iOS && !iOSSafari) {
                    $("#image-download-url").attr('href', $(this.opts.$orig[0]).attr('href'));
                    // $("#image-download-url").attr('target', '_blank');
                } else {
                    let download_url = $(this.opts.$orig[0]).attr('data-download'); 
                    $("#image-download-url").attr('href', download_url);
                }
            } else {
                $("#image-download-url").hide();
            }
        },
        infobar: false,
        arrows: false,
        buttons: [
            "close"
        ],
        transitionEffect: "fade",
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption with-download">' + 
                '<a href="#" class="cta download-modal" id="image-download-url">Download</a>' +
                '<div class="share-wrap">' +
                    '<div class="share-box modal">' +
                        '<ul class="social-media modal">' +
                            '<li><a target="_blank" id="facebook" href="#" class="share-icon fb"></a></li>' +
                            '<li><a target="_blank" id="twitter" href="#" class="share-icon twitter"></a></li>' +
                            '<li><a target="_blank" id="weibo" href="#" class="share-icon anon"></a></li>' +
                            '<li><a id="email" href="#" class="share-icon mail"></a></li>' +
                            '<li><a id="copy" title="" href="javascript:void(0);" class="share-icon link"></a></li>' +
                        '</ul>' +
                        '<p>'+ shareText +'</p>' +
                    '</div>' + 
                    '<a href="#" id="share-modal" class="cta share modal">'+ shareTextLabel +'</a>' + 
                '</div>' +
            '</div>' +
            "</div>" +
            "</div>",
    });

    $(window).resize(function() {
        adjustHeight();
    })

    function adjustHeight() {
        $(".photo-thumb").height($(".photo-thumb").width());
    }

    adjustHeight();


});